import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AppSplash } from "./ProtectedRoute";
import { homeRoute } from "../lib/routeMemory";

// Google girişinden dönüş: #session_id=… bir kez backend'e verilir, oturum kurulunca ana ekrana geçilir
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      const u = sid ? await googleSession(sid) : false;
      navigate(u ? homeRoute(u) : "/login", { replace: true });
    })();
  }, [location.hash, googleSession, navigate]);

  return <AppSplash />;
}
